import type { Lesson } from "@/core/types";

export const lektionVortragen: Lesson = {
  id: "vortragen",
  title: "Vortragen",
  summary: "Die Folie begleitet den Vortrag – nicht umgekehrt.",
  durationMinutes: 7,
  learningGoals: [
    "Den Ablauf eines Vortrags an der Foliendramaturgie ausrichten",
    "Mit Zwischenfragen und Zeitdruck umgehen",
  ],
  steps: [
    {
      id: "dramaturgie",
      title: "Die Dramaturgie der Folienfolge",
      explanation: [
        "Eine Präsentation hat eine Reihenfolge, und die trägt Bedeutung. Bewährt hat " +
          "sich ein einfacher Bogen: Womit fangen wir an – warum ist das Thema " +
          "überhaupt wichtig? Was wissen wir? Was folgt daraus? Was ist zu tun?",
        "Für die Folien heißt das: Die erste Inhaltsfolie stellt die Frage, nicht die " +
          "Antwort. Die Antwort kommt am Ende – oder, wenn die Zeit knapp ist und das " +
          "Publikum die Entscheidung braucht, ganz am Anfang und dann noch einmal am " +
          "Ende.",
        "Abschnittstrenner helfen dabei mehr, als man vermutet. Eine Folie mit dem Layout " +
          "„Abschnittsüberschrift“ zwischen zwei Themen gibt dem Publikum einen Moment " +
          "zum Sortieren und dir einen natürlichen Punkt zum Luftholen. Dazu mehr im " +
          "Modul „Abschnitte und große Präsentationen“.",
        "Die Schlussfolie ist keine Danksagung. „Vielen Dank für Ihre Aufmerksamkeit“ " +
          "steht am Ende der meisten Präsentationen und ist genau die Folie, die während " +
          "der gesamten Diskussion an der Wand hängt. Besser steht dort die Kernaussage " +
          "oder die Frage, über die diskutiert werden soll.",
      ],
      keyPoints: [
        "Bogen: Warum wichtig – was wissen wir – was folgt daraus – was ist zu tun.",
        "Abschnittstrenner geben Struktur und Atempausen.",
        "Auf der Schlussfolie steht die Kernaussage, nicht „Vielen Dank“.",
      ],
    },
    {
      id: "fragen-und-zeit",
      title: "Zwischenfragen und Zeit",
      explanation: [
        "Eine Zwischenfrage, die auf eine spätere Folie zielt, ist der häufigste Grund, " +
          "aus dem Vortragende die Reihenfolge verlassen. Das geht gut, wenn man weiß, " +
          "wie: Foliennummer tippen und Enter drücken springt direkt dorthin; die " +
          "Foliensortierung in der Referentenansicht zeigt alle Folien als Miniaturen.",
        "Für Fragen, die über den Vortrag hinausgehen, sind Reservefolien da – " +
          "ausgeblendete Folien am Ende, wie im Modul „Folien und Layouts“ beschrieben. " +
          "Sie stören den Ablauf nicht und stehen bereit.",
        "Beim Zeitmanagement hilft eine Vorüberlegung: Welche Folien sind Kern, welche " +
          "sind Vertiefung? Wenn die Zeit knapp wird, überspringt man die Vertiefung – " +
          "und zwar sichtbar und angekündigt („Das Detail dazu überspringe ich, es steht " +
          "in den Unterlagen“). Unsichtbares Kürzen mitten im Satz merkt das Publikum " +
          "sofort.",
        "Als Faustregel für die Planung: etwa eine bis zwei Minuten pro Inhaltsfolie. " +
          "Wer für zwanzig Minuten dreißig Folien vorbereitet hat, wird nicht schneller " +
          "sprechen – sondern die letzten zehn Folien durchblättern.",
      ],
      keyPoints: [
        "Foliennummer + Enter springt während der Präsentation gezielt zu einer Folie.",
        "Reservefolien am Ende, ausgeblendet über Bildschirmpräsentation → Folie ausblenden.",
        "Planungsgröße: ein bis zwei Minuten pro Inhaltsfolie.",
      ],
    },
  ],
};
